// extracted by mini-css-extract-plugin
export var container = "_hm-0";
export var content = "_hm-3";
export var customerTitle = "_hm-4";
export var empty = "_hm-5";
export var gray = "_hm-6";
export var header = "_hm-7";
export var info = "_hm-8";
export var loading = "_hm-2";
export var loadingCard = "_hm-9";
export var oneLine = "_hm-a";
export var personName = "_hm-e";
export var pillContainer = "_hm-b";
export var selected = "_hm-1";
export var text = "_hm-c";
export var twoLines = "_hm-d";
export var unread = "_hm-f";
export var unreadIndicator = "_hm-g";